import React from 'react';
import './App.css';
import {ThemeProvider} from "@mui/material";
import {BrowserRouter as Router} from "react-router-dom";
import theme from "./theme";
import {Main} from "./Main";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

function App() {
  return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={theme}>
            <Router>
              <div style={{zoom: "100%", backgroundColor: "#fbfbfb", height: "100vh", overflow: "auto"}}>
                <Main/>
              </div>
            </Router>
          </ThemeProvider>
      </LocalizationProvider>
  );
}

export default App;
